{
  me {
    brContact {
      id
      fullName
      brSalesPerson {
        id
        salesPartnerDonationEnabledFlg
        pendingAgreementDownloadUrl
        adminBrContact {
          id
        }
      }
      pendingTermsOfAdhesion {
        id
        pendingSignatureDownloadUrl
        pendingSignatureViewUrl: pendingSignatureDownloadUrl(viewInline: true)
        brPowerPlan {
          id
          discountRate
        }
        brConsumerUnit {
          id
          name
          consumerUnitCode
          currentDiscountRate
          utilityCompany {
            id
            name
          }
          brCustomer {
            id
            name
            type
            cpf
            cnpj
            salesPartnerDonationRate
            primaryBrContact {
              id
              fullName
              cpf
            }
          }
        }
      }
    }
  }
}
